import locale from "localization/en";

export const lpgSalesColumn = [
  { key: "itemCode", text: locale.itemCode },
  { key: "product", text: locale.product },
  { key: "variant", text: locale.variant },
  { key: "unitPrice", text: locale.unitPrice },
  { key: "quantitySold", text: locale.quantitySold },
  { key: "amount", text: locale.amount },
  { key: "discounts", text: `${locale.discount}/${locale.premium}` },
  { key: "finalAmount", text: locale.finalAmount },
];
